import React from 'react';
import { motion } from 'framer-motion';
import { triggerChat } from '@/utils/chatTrigger';

const FinalCTA = () => {
  return (
    <section className="py-32 relative overflow-hidden">
      <div className="absolute inset-0 bg-navy"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/10 rounded-full blur-[100px] pointer-events-none"></div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
        <motion.div initial={{ opacity: 0, scale: 0.95 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
          <h2 className="text-5xl md:text-7xl font-anton uppercase tracking-wide text-white mb-6 leading-tight">
            MORE APPOINTMENTS. <br/>MORE LEADS. <span className="text-gold">LESS ON YOUR PLATE.</span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 mb-12 font-medium max-w-2xl mx-auto">
            Let your website do the work of turning visitors into booked appointments — so your team can stay focused on what they do best.
          </p>
          <button 
            onClick={triggerChat}
            className="inline-flex justify-center items-center px-10 py-5 rounded-md bg-gold text-navy font-bold text-xl tracking-wide uppercase transition-all hover:bg-gold-hover hover:-translate-y-1 hover:shadow-[0_15px_40px_rgba(245,166,35,0.4)]"
          >
            Book Your Demo
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;